import React, { useContext } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Home = () => {
  const { isAuthenticated, currentUser } = useContext(AuthContext);
  const navigate = useNavigate();
  
  // Redirect if already logged in
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate(currentUser?.role === 'admin' ? '/admin/dashboard' : '/dashboard');
    }
  }, [isAuthenticated, currentUser, navigate]);
  
  return (
    <div className="page-fade-in">
      <Container fluid className="p-0">
        {/* Hero Section */}
        <div className="text-center py-5" style={{ 
          background: 'linear-gradient(135deg, #E8E0F0 0%, #D6E6F5 50%, #D4EDDA 100%)',
          minHeight: '260px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div>
            <div style={{
              width: 64, height: 64, borderRadius: '18px', margin: '0 auto 16px',
              background: 'linear-gradient(135deg, #7C6FA0, #6BA3C7)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 6px 20px rgba(124,111,160,0.25)'
            }}>
              <span style={{ fontSize: '1.8rem' }}>&#128203;</span>
            </div>
            <h1 style={{ fontWeight: 700, color: '#2D2D2D', fontSize: '2.4rem', letterSpacing: '-0.5px' }}>WINGGS Daily Report Management</h1>
            <p style={{ color: '#757575', fontSize: '1.05rem', marginTop: 8 }}>
              Streamlined Reporting for WINGGS IT Team
            </p>
          </div>
        </div>

        <Container className="py-5">
          <Row className="justify-content-center text-center mb-4">
            <Col md={8}>
              <h4 style={{ fontWeight: 600, color: '#424242' }}>Select Your Role</h4>
              <p style={{ color: '#9E9E9E', fontSize: '0.95rem' }}>
                Choose your role to access the appropriate dashboard
              </p>
            </Col>
          </Row>
          
          <Row className="justify-content-center">
            <Col md={5} lg={4} className="mb-4">
              <Card className="h-100 text-center hover-card" style={{ 
                border: '1px solid #EEEEEE', borderRadius: 16, 
                boxShadow: '0 4px 16px rgba(124,111,160,0.06)',
                background: 'linear-gradient(180deg, #fff 0%, #F0E6FF 100%)'
              }}>
                <Card.Body className="d-flex flex-column p-4">
                  <div style={{
                    width: 80, height: 80, borderRadius: '50%', margin: '0 auto 16px',
                    background: '#E8E0F0', display: 'flex', alignItems: 'center', justifyContent: 'center'
                  }}>
                    <span style={{ fontSize: '2rem' }}>&#128104;&#8205;&#128187;</span>
                  </div>
                  <Card.Title style={{ fontSize: '1.3rem', fontWeight: 700, color: '#2D2D2D' }}>Developer</Card.Title>
                  <Card.Text style={{ color: '#9E9E9E', fontSize: '0.9rem', marginBottom: '1.5rem' }}>
                    Submit your daily reports and track your progress
                  </Card.Text>
                  <div className="mt-auto">
                    <Button as={Link} to="/login" variant="primary" className="w-100" style={{ padding: '0.65rem', borderRadius: 10, fontWeight: 600 }}>
                      Login as Developer
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            
            <Col md={5} lg={4} className="mb-4">
              <Card className="h-100 text-center hover-card" style={{ 
                border: '1px solid #EEEEEE', borderRadius: 16, 
                boxShadow: '0 4px 16px rgba(107,175,123,0.06)',
                background: 'linear-gradient(180deg, #fff 0%, #D4EDDA 100%)'
              }}>
                <Card.Body className="d-flex flex-column p-4">
                  <div style={{
                    width: 80, height: 80, borderRadius: '50%', margin: '0 auto 16px',
                    background: '#D4EDDA', display: 'flex', alignItems: 'center', justifyContent: 'center'
                  }}>
                    <span style={{ fontSize: '2rem' }}>&#128737;&#65039;</span>
                  </div>
                  <Card.Title style={{ fontSize: '1.3rem', fontWeight: 700, color: '#2D2D2D' }}>Administrator</Card.Title>
                  <Card.Text style={{ color: '#9E9E9E', fontSize: '0.9rem', marginBottom: '1.5rem' }}>
                    Manage team reports and track development progress
                  </Card.Text>
                  <div className="mt-auto">
                    <Button as={Link} to="/login" variant="success" className="w-100" style={{ padding: '0.65rem', borderRadius: 10, fontWeight: 600 }}>
                      Login as Admin
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="justify-content-center text-center mt-4">
            <Col md={8}>
              <p style={{ color: '#BDBDBD', fontSize: '0.85rem' }}>
                Please contact an administrator if you need an account
              </p>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
};

export default Home;
